import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0","key":"svg-0"}],["path",{"d":"M6 21v-2a4 4 0 0 1 4 -4h5","key":"svg-1"}],["path",{"d":"M18.5 18.5l-3.5 3.5l-1.5 -1.5","key":"svg-2"}],["path",{"d":"M18.554 18.414a2 2 0 1 1 2.828 -2.828a2 2 0 0 1 -2.828 2.828","key":"svg-3"}],["path",{"d":"M16 19l1 1","key":"svg-4"}]]

const IconUserKey = createReactComponent('outline', 'user-key', 'UserKey', __iconNode);

export default IconUserKey;